import script from "./PolitiqueConfidentialite.vue?vue&type=script&setup=true&lang=js"
export * from "./PolitiqueConfidentialite.vue?vue&type=script&setup=true&lang=js"

import "./PolitiqueConfidentialite.vue?vue&type=style&index=0&id=09fb2f74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09fb2f74"]])

export default __exports__